import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { StyledSelect, StyledSelectPropTypes } from 'site-modules/shared/components/styled-select/styled-select';

import './select.scss';

export function Select({ onChange, isLoading = false, ...restProps }) {
  const handleChange = useCallback(({ value, label }) => onChange(value, label), [onChange]);

  return (
    <StyledSelect
      {...restProps}
      wrapperClassName={classnames('lease-deals-select-wrapper pos-r', { loading: isLoading })}
      labelClassName="lease-deals-select-label pos-a size-12 text-cool-gray-30 mb-0"
      overrideClasses="lease-deals-select form-control size-16 px-1 rounded-8"
      optionClassName="size-16"
      toggleClassName="text-cool-gray-50"
      onChange={handleChange}
      required
    />
  );
}

Select.propTypes = {
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  ...StyledSelectPropTypes,
};

Select.displayName = 'Select';
